import React from 'react';

import SvgContainer from '../SvgContainer';

const Profile = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9078_100937)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 0C3.58222 0 0 3.58497 0 8.00614C0 11.7157 2.52444 14.8292 5.94667 15.7365C7.42307 16.128 8.88889 16.0453 10.0533 15.7365C13.4756 14.8292 16 11.7157 16 8.00614C16 3.58497 12.4178 0 8 0ZM10.6667 4.44786C10.6667 2.97117 9.47556 1.77914 8 1.77914C6.52444 1.77914 5.33333 2.97117 5.33333 4.44786C5.33333 5.92455 6.52444 7.11657 8 7.11657C9.47556 7.11657 10.6667 5.92455 10.6667 4.44786ZM2.66667 11.6356C3.81333 13.3614 5.77778 14.5 8 14.5C10.2222 14.5 12.1867 13.3614 13.3333 11.6356C13.3067 9.86535 9.76889 8.89571 8 8.89571C6.22222 8.89571 2.69333 9.86535 2.66667 11.6356Z"
                />
            </g>
            <defs>
                <clipPath id="clip0_9078_100937">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Profile;
